// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.crypto-container {
  padding: 1.5rem;
  max-width: 1200px;
  margin: 0 auto;
}

.crypto-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.crypto-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.crypto-title h1 {
  margin: 0;
  font-size: 1.75rem;
  color: var(--text-primary, #e2e8f0);
}

.crypto-title-icon {
  font-size: 2rem;
  color: #f7931a;
}

.crypto-header-actions {
  display: flex;
  gap: 0.75rem;
}

/* Buttons */
.crypto-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1.2rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.2s;
}

.crypto-btn-add {
  background: linear-gradient(135deg, #f7931a, #e8850f);
  color: white;
}

.crypto-btn-add:hover {
  background: linear-gradient(135deg, #e8850f, #d4780e);
}

.crypto-btn-refresh {
  background: var(--bg-tertiary, #2d3748);
  color: var(--text-primary, #e2e8f0);
  border: 1px solid var(--border-color, #4a5568);
}

.crypto-btn-refresh:hover {
  background: var(--bg-secondary, #374151);
}

.crypto-btn-refresh:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.crypto-btn-submit {
  background: linear-gradient(135deg, #48bb78, #38a169);
  color: white;
  white-space: nowrap;
}

.crypto-btn-submit:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* Total Value Card */
.crypto-total-card {
  background: linear-gradient(135deg, #1a1a2e, #16213e);
  border: 1px solid #f7931a33;
  border-radius: 12px;
  padding: 1.5rem 2rem;
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.crypto-total-label {
  font-size: 1rem;
  color: #a0aec0;
}

.crypto-total-value {
  font-size: 2rem;
  font-weight: 700;
  color: #f7931a;
}

/* Add Form */
.crypto-add-form {
  background: var(--bg-secondary, #1e293b);
  border: 1px solid var(--border-color, #334155);
  border-radius: 12px;
  padding: 1.25rem;
  margin-bottom: 1.5rem;
  overflow: visible;
  position: relative;
  z-index: 10;
}

.crypto-form-row {
  display: flex;
  gap: 0.75rem;
  align-items: flex-start;
}

.crypto-search-wrapper {
  position: relative;
  flex: 2 1;
}

.crypto-search-icon {
  position: absolute;
  left: 12px;
  top: 12px;
  color: #64748b;
  z-index: 1;
}

.crypto-search-input {
  width: 100%;
  padding: 0.6rem 0.75rem 0.6rem 2.25rem;
  background: var(--bg-tertiary, #0f172a);
  border: 1px solid var(--border-color, #334155);
  border-radius: 8px;
  color: var(--text-primary, #e2e8f0);
  font-size: 0.9rem;
  box-sizing: border-box;
}

.crypto-search-input:focus {
  outline: none;
  border-color: #f7931a;
}

.crypto-selected-coin {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 0.75rem 0.6rem 2.25rem;
  background: var(--bg-tertiary, #0f172a);
  border: 1px solid #f7931a;
  border-radius: 8px;
  color: var(--text-primary, #e2e8f0);
  font-size: 0.9rem;
}

.crypto-clear-coin {
  background: none;
  border: none;
  color: #64748b;
  cursor: pointer;
  padding: 0.25rem;
  margin-left: auto;
}

.crypto-clear-coin:hover {
  color: #ef4444;
}

.crypto-coin-thumb {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}

/* Search Dropdown */
.crypto-search-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: var(--bg-secondary, #1e293b);
  border: 1px solid var(--border-color, #334155);
  border-radius: 8px;
  margin-top: 4px;
  max-height: 300px;
  overflow-y: auto;
  z-index: 100;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.crypto-search-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 0.75rem;
  cursor: pointer;
  transition: background 0.15s;
}

.crypto-search-item:hover {
  background: var(--bg-tertiary, #334155);
}

.crypto-search-name {
  flex: 1 1;
  color: var(--text-primary, #e2e8f0);
}

.crypto-search-symbol {
  color: #64748b;
  font-size: 0.8rem;
  text-transform: uppercase;
}

.crypto-search-rank {
  color: #64748b;
  font-size: 0.75rem;
  background: var(--bg-tertiary, #0f172a);
  padding: 2px 6px;
  border-radius: 4px;
}

.crypto-amount-input {
  flex: 1 1;
  padding: 0.6rem 0.75rem;
  background: var(--bg-tertiary, #0f172a);
  border: 1px solid var(--border-color, #334155);
  border-radius: 8px;
  color: var(--text-primary, #e2e8f0);
  font-size: 0.9rem;
}

.crypto-amount-input:focus {
  outline: none;
  border-color: #f7931a;
}

/* Empty State */
.crypto-empty {
  text-align: center;
  padding: 3rem 1rem;
  color: #64748b;
}

.crypto-empty-icon {
  font-size: 3rem;
  color: #334155;
  margin-bottom: 1rem;
}

.crypto-empty p {
  margin: 0.5rem 0;
}

.crypto-empty-hint {
  font-size: 0.85rem;
  color: #475569;
}

/* Table */
.crypto-table-wrapper {
  background: var(--bg-secondary, #1e293b);
  border: 1px solid var(--border-color, #334155);
  border-radius: 12px;
  overflow: hidden;
}

.crypto-table {
  width: 100%;
  border-collapse: collapse;
}

.crypto-table thead {
  background: var(--bg-tertiary, #0f172a);
}

.crypto-table th {
  padding: 0.75rem 1rem;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #64748b;
  border-bottom: 1px solid var(--border-color, #334155);
}

.crypto-table td {
  padding: 0.85rem 1rem;
  color: var(--text-primary, #e2e8f0);
  border-bottom: 1px solid var(--border-color, #1e293b);
  font-size: 0.9rem;
}

.crypto-table tbody tr:hover {
  background: var(--bg-tertiary, #1a2332);
}

.text-right {
  text-align: right;
}

.text-center {
  text-align: center;
}

.crypto-coin-cell {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.crypto-coin-name {
  font-weight: 600;
  color: var(--text-primary, #e2e8f0);
}

.crypto-coin-symbol {
  font-size: 0.75rem;
  color: #64748b;
  text-transform: uppercase;
}

.crypto-value {
  font-weight: 600;
  color: #f7931a;
}

.crypto-change {
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.25rem;
}

.crypto-change.positive {
  color: #48bb78;
}

.crypto-change.negative {
  color: #ef4444;
}

/* Inline Edit */
.crypto-edit-inline {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  justify-content: flex-end;
}

.crypto-edit-input {
  width: 100px;
  padding: 0.3rem 0.5rem;
  background: var(--bg-tertiary, #0f172a);
  border: 1px solid #f7931a;
  border-radius: 6px;
  color: var(--text-primary, #e2e8f0);
  font-size: 0.85rem;
  text-align: right;
}

.crypto-inline-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.3rem;
  border-radius: 4px;
  font-size: 0.8rem;
}

.crypto-inline-btn.save {
  color: #48bb78;
}

.crypto-inline-btn.save:hover {
  background: rgba(72, 187, 120, 0.15);
}

.crypto-inline-btn.cancel {
  color: #ef4444;
}

.crypto-inline-btn.cancel:hover {
  background: rgba(239, 68, 68, 0.15);
}

/* Action Buttons */
.crypto-actions {
  display: flex;
  gap: 0.35rem;
  justify-content: center;
}

.crypto-action-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.4rem;
  border-radius: 6px;
  font-size: 0.85rem;
  transition: all 0.15s;
}

.crypto-action-btn.edit {
  color: #63b3ed;
}

.crypto-action-btn.edit:hover {
  background: rgba(99, 179, 237, 0.15);
}

.crypto-action-btn.delete {
  color: #ef4444;
}

.crypto-action-btn.delete:hover {
  background: rgba(239, 68, 68, 0.15);
}

/* Loading */
.crypto-loading {
  text-align: center;
  padding: 3rem;
  color: #64748b;
  font-size: 1rem;
}

/* Responsive */
@media (max-width: 768px) {
  .crypto-container {
    padding: 1rem;
  }

  .crypto-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .crypto-total-card {
    flex-direction: column;
    text-align: center;
    gap: 0.5rem;
  }

  .crypto-total-value {
    font-size: 1.5rem;
  }

  .crypto-form-row {
    flex-direction: column;
  }

  .crypto-table-wrapper {
    overflow-x: auto;
  }

  .crypto-table {
    min-width: 600px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/crypto/CryptoPortfolio.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,uCAAuC;EACvC,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA,qBAAqB;AACrB;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,wCAAwC;EACxC,8CAA8C;EAC9C,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,uCAAuC;EACvC,8CAA8C;EAC9C,kBAAkB;EAClB,mCAAmC;EACnC,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sCAAsC;EACtC,uCAAuC;EACvC,yBAAyB;EACzB,kBAAkB;EAClB,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,wCAAwC;EACxC,8CAA8C;EAC9C,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,SAAO;EACP,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,uCAAuC;EACvC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,uCAAuC;EACvC,8CAA8C;EAC9C,kBAAkB;EAClB,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,wCAAwC;EACxC,8CAA8C;EAC9C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,qDAAqD;AACvD;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,qDAAqD;EACrD,iBAAiB;AACnB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,uCAAuC;EACvC,yBAAyB;EACzB,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".crypto-container {\n  padding: 1.5rem;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.crypto-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.crypto-title {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.crypto-title h1 {\n  margin: 0;\n  font-size: 1.75rem;\n  color: var(--text-primary, #e2e8f0);\n}\n\n.crypto-title-icon {\n  font-size: 2rem;\n  color: #f7931a;\n}\n\n.crypto-header-actions {\n  display: flex;\n  gap: 0.75rem;\n}\n\n/* Buttons */\n.crypto-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.6rem 1.2rem;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-weight: 500;\n  transition: all 0.2s;\n}\n\n.crypto-btn-add {\n  background: linear-gradient(135deg, #f7931a, #e8850f);\n  color: white;\n}\n\n.crypto-btn-add:hover {\n  background: linear-gradient(135deg, #e8850f, #d4780e);\n}\n\n.crypto-btn-refresh {\n  background: var(--bg-tertiary, #2d3748);\n  color: var(--text-primary, #e2e8f0);\n  border: 1px solid var(--border-color, #4a5568);\n}\n\n.crypto-btn-refresh:hover {\n  background: var(--bg-secondary, #374151);\n}\n\n.crypto-btn-refresh:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.crypto-btn-submit {\n  background: linear-gradient(135deg, #48bb78, #38a169);\n  color: white;\n  white-space: nowrap;\n}\n\n.crypto-btn-submit:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.spinning {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n/* Total Value Card */\n.crypto-total-card {\n  background: linear-gradient(135deg, #1a1a2e, #16213e);\n  border: 1px solid #f7931a33;\n  border-radius: 12px;\n  padding: 1.5rem 2rem;\n  margin-bottom: 1.5rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.crypto-total-label {\n  font-size: 1rem;\n  color: #a0aec0;\n}\n\n.crypto-total-value {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #f7931a;\n}\n\n/* Add Form */\n.crypto-add-form {\n  background: var(--bg-secondary, #1e293b);\n  border: 1px solid var(--border-color, #334155);\n  border-radius: 12px;\n  padding: 1.25rem;\n  margin-bottom: 1.5rem;\n  overflow: visible;\n  position: relative;\n  z-index: 10;\n}\n\n.crypto-form-row {\n  display: flex;\n  gap: 0.75rem;\n  align-items: flex-start;\n}\n\n.crypto-search-wrapper {\n  position: relative;\n  flex: 2;\n}\n\n.crypto-search-icon {\n  position: absolute;\n  left: 12px;\n  top: 12px;\n  color: #64748b;\n  z-index: 1;\n}\n\n.crypto-search-input {\n  width: 100%;\n  padding: 0.6rem 0.75rem 0.6rem 2.25rem;\n  background: var(--bg-tertiary, #0f172a);\n  border: 1px solid var(--border-color, #334155);\n  border-radius: 8px;\n  color: var(--text-primary, #e2e8f0);\n  font-size: 0.9rem;\n  box-sizing: border-box;\n}\n\n.crypto-search-input:focus {\n  outline: none;\n  border-color: #f7931a;\n}\n\n.crypto-selected-coin {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.6rem 0.75rem 0.6rem 2.25rem;\n  background: var(--bg-tertiary, #0f172a);\n  border: 1px solid #f7931a;\n  border-radius: 8px;\n  color: var(--text-primary, #e2e8f0);\n  font-size: 0.9rem;\n}\n\n.crypto-clear-coin {\n  background: none;\n  border: none;\n  color: #64748b;\n  cursor: pointer;\n  padding: 0.25rem;\n  margin-left: auto;\n}\n\n.crypto-clear-coin:hover {\n  color: #ef4444;\n}\n\n.crypto-coin-thumb {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n}\n\n/* Search Dropdown */\n.crypto-search-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: var(--bg-secondary, #1e293b);\n  border: 1px solid var(--border-color, #334155);\n  border-radius: 8px;\n  margin-top: 4px;\n  max-height: 300px;\n  overflow-y: auto;\n  z-index: 100;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n}\n\n.crypto-search-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.6rem 0.75rem;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.crypto-search-item:hover {\n  background: var(--bg-tertiary, #334155);\n}\n\n.crypto-search-name {\n  flex: 1;\n  color: var(--text-primary, #e2e8f0);\n}\n\n.crypto-search-symbol {\n  color: #64748b;\n  font-size: 0.8rem;\n  text-transform: uppercase;\n}\n\n.crypto-search-rank {\n  color: #64748b;\n  font-size: 0.75rem;\n  background: var(--bg-tertiary, #0f172a);\n  padding: 2px 6px;\n  border-radius: 4px;\n}\n\n.crypto-amount-input {\n  flex: 1;\n  padding: 0.6rem 0.75rem;\n  background: var(--bg-tertiary, #0f172a);\n  border: 1px solid var(--border-color, #334155);\n  border-radius: 8px;\n  color: var(--text-primary, #e2e8f0);\n  font-size: 0.9rem;\n}\n\n.crypto-amount-input:focus {\n  outline: none;\n  border-color: #f7931a;\n}\n\n/* Empty State */\n.crypto-empty {\n  text-align: center;\n  padding: 3rem 1rem;\n  color: #64748b;\n}\n\n.crypto-empty-icon {\n  font-size: 3rem;\n  color: #334155;\n  margin-bottom: 1rem;\n}\n\n.crypto-empty p {\n  margin: 0.5rem 0;\n}\n\n.crypto-empty-hint {\n  font-size: 0.85rem;\n  color: #475569;\n}\n\n/* Table */\n.crypto-table-wrapper {\n  background: var(--bg-secondary, #1e293b);\n  border: 1px solid var(--border-color, #334155);\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.crypto-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.crypto-table thead {\n  background: var(--bg-tertiary, #0f172a);\n}\n\n.crypto-table th {\n  padding: 0.75rem 1rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #64748b;\n  border-bottom: 1px solid var(--border-color, #334155);\n}\n\n.crypto-table td {\n  padding: 0.85rem 1rem;\n  color: var(--text-primary, #e2e8f0);\n  border-bottom: 1px solid var(--border-color, #1e293b);\n  font-size: 0.9rem;\n}\n\n.crypto-table tbody tr:hover {\n  background: var(--bg-tertiary, #1a2332);\n}\n\n.text-right {\n  text-align: right;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.crypto-coin-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n}\n\n.crypto-coin-name {\n  font-weight: 600;\n  color: var(--text-primary, #e2e8f0);\n}\n\n.crypto-coin-symbol {\n  font-size: 0.75rem;\n  color: #64748b;\n  text-transform: uppercase;\n}\n\n.crypto-value {\n  font-weight: 600;\n  color: #f7931a;\n}\n\n.crypto-change {\n  font-size: 0.85rem;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.25rem;\n}\n\n.crypto-change.positive {\n  color: #48bb78;\n}\n\n.crypto-change.negative {\n  color: #ef4444;\n}\n\n/* Inline Edit */\n.crypto-edit-inline {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  justify-content: flex-end;\n}\n\n.crypto-edit-input {\n  width: 100px;\n  padding: 0.3rem 0.5rem;\n  background: var(--bg-tertiary, #0f172a);\n  border: 1px solid #f7931a;\n  border-radius: 6px;\n  color: var(--text-primary, #e2e8f0);\n  font-size: 0.85rem;\n  text-align: right;\n}\n\n.crypto-inline-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0.3rem;\n  border-radius: 4px;\n  font-size: 0.8rem;\n}\n\n.crypto-inline-btn.save {\n  color: #48bb78;\n}\n\n.crypto-inline-btn.save:hover {\n  background: rgba(72, 187, 120, 0.15);\n}\n\n.crypto-inline-btn.cancel {\n  color: #ef4444;\n}\n\n.crypto-inline-btn.cancel:hover {\n  background: rgba(239, 68, 68, 0.15);\n}\n\n/* Action Buttons */\n.crypto-actions {\n  display: flex;\n  gap: 0.35rem;\n  justify-content: center;\n}\n\n.crypto-action-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0.4rem;\n  border-radius: 6px;\n  font-size: 0.85rem;\n  transition: all 0.15s;\n}\n\n.crypto-action-btn.edit {\n  color: #63b3ed;\n}\n\n.crypto-action-btn.edit:hover {\n  background: rgba(99, 179, 237, 0.15);\n}\n\n.crypto-action-btn.delete {\n  color: #ef4444;\n}\n\n.crypto-action-btn.delete:hover {\n  background: rgba(239, 68, 68, 0.15);\n}\n\n/* Loading */\n.crypto-loading {\n  text-align: center;\n  padding: 3rem;\n  color: #64748b;\n  font-size: 1rem;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .crypto-container {\n    padding: 1rem;\n  }\n\n  .crypto-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .crypto-total-card {\n    flex-direction: column;\n    text-align: center;\n    gap: 0.5rem;\n  }\n\n  .crypto-total-value {\n    font-size: 1.5rem;\n  }\n\n  .crypto-form-row {\n    flex-direction: column;\n  }\n\n  .crypto-table-wrapper {\n    overflow-x: auto;\n  }\n\n  .crypto-table {\n    min-width: 600px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
